<button [matMenuTriggerFor]="menu" [title]="'ui.titles.language' | transloco" id="all_toolbar_btn_change-language"
  mat-icon-button>
  <mat-icon>language</mat-icon>
</button>

<mat-menu #menu>
  @for (language of languages; track language) {
    <button (click)="changeLanguage.emit(language)"
      [id]="'all_toolbar_btn_change-language-'+language.name" mat-menu-item>
      <mat-icon>{{ currentLanguage === language.name ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
      <span>{{ language.label }}</span>
    </button>
  }
</mat-menu>
